import { IEnvironment } from '../models';
import { environment } from './environment';

export const environmentStg: IEnvironment = {
  ...environment,
  envName: 'staging',
  production: false,
};
